import { FooterIcon } from 'src/utils/Icon'
import { ExplanationImg } from './style'

const MoveOutPageImage = () => {
  return (
    <a href="https://www.saibugas.co.jp/management_company/index/?id=791880" target="_blank" rel="noreferrer">
      <ExplanationImg src={FooterIcon.MoveOut} />
    </a>
  )
}

export default MoveOutPageImage
